export default __webpack_public_path__ + "static/media/React.0c27dfa2.png";